module.exports = __webpack_public_path__ + "static/media/symbols.706269d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/picsaos-sprite/svg/symbols.svg
// module id = 472
// module chunks = 0